<div class="card-group-name">
    {{ name() }}
</div>
<div *ngFor="let card of cards();  trackBy: trackByCardType">
    <div [ngSwitch]="card.type">
        <course-card [card]="card" *ngSwitchCase="CardType.CourseCard"/>
        <participant-card [card]="card" *ngSwitchCase="CardType.ParticipantCard"/>
        <team-card [card]="card" *ngSwitchCase="CardType.TeamCard"/>
        <group-card [card]="card" *ngSwitchCase="CardType.GroupCard"/>
    </div>
</div>